export default __webpack_public_path__ + "static/app_screenshot_2-cd06038064540300aaaf999bd7d45d22.webp";